import { Injectable } from '@angular/core';
import { AttachDocumentService } from 'src/app/shared/data-service/attach-document.service';
import { EolctDataService } from 'src/app/shared/data-service/eolct-data.service';
import { OrderDataService } from 'src/app/shared/data-service/order-data.service';
import { CurrentOrder } from 'src/app/shared/models/current-order.model';
import { OrderDetails } from 'src/app/shared/models/my-orders/order-details.model';
import { ReportTemplate } from 'src/app/shared/models/report-template.model';
import { CurrentOrderService } from 'src/app/shared/services/current-order.service';
import { OrderDetailsMapperService } from 'src/app/shared/services/order-details-mapper.service';
import { LinkedObjectType } from 'src/app/shared/enums/linked-object-type.enum';
import { File } from 'src/app/shared/models/attach-document/file.model';
import { throwError } from 'rxjs';
import { SettingsKey } from 'src/app/core/store/settings-config.keys';
import { LABSITE, ORDERINGSERVICE } from '../guided-order/samples/constants/sample-constants';
import { SettingsService } from 'src/app/shared/data-service/settings.service';

@Injectable({
  providedIn: 'root'
})
export class OrderSummaryService {

  sampleQuantityDisplayFlag: boolean = false;
  enableSampleQuantity: string;
  get CurrentOrder() { return this.currentOrderService.currentOrder; }

  constructor(
    private currentOrderService: CurrentOrderService,
    private eolctDataService: EolctDataService,
    private orderDataService: OrderDataService,
    private settingsService: SettingsService,
    private orderDetailsMapperService: OrderDetailsMapperService,
    private attachDocumentService: AttachDocumentService) {
  }

  getReportTemplate(): Promise<ReportTemplate[]> {
    return this.orderDataService.getReportTemplates(this.currentOrderService.currentOrder.account.code).toPromise();
  }

  async getOrderAttachments(orderId: string, callback: () => void) {
    let files: File[] = [];
    await this.attachDocumentService.getAttachments(orderId)
      .toPromise()
      .then(res => {
        files = res;
      })
      .catch((error) => {
        if (error.status !== 500) {
          callback();
        } else {
          return throwError(error);
        }
      });

    callback();
    return files;
  }

  async getOrderSummary(orderDetails: OrderDetails, callback: () => void) {
    await this.orderDataService.getConfirmedOrder(orderDetails.orderCode).toPromise().then(async x => {
      const data: CurrentOrder = {};
      data.orderTemplate = orderDetails.orderTemplate ?? {};
      const attachments = await this.getOrderAttachments(x.order.orderDetails.orderReference, () => { });
      await this.orderDetailsMapperService.mapOrderDetails(data, x.order,
        attachments?.filter(y => y.linkedObjectType === LinkedObjectType.Order));
      x.order.samples.forEach(x => {
        this.updateExecutionNumber(x.invoiceableItem.testQuotationLines);
        this.updateExecutionNumber(x.invoiceableItem.packageQuotationLines);
        this.updateExecutionNumber(x.invoiceableItem.tests);

        x.invoiceableItem.customerPackages.forEach(customerPackage => {
          customerPackage.executionNumber = customerPackage.executionNumber > 0 ? customerPackage.executionNumber : 1;
          this.updateExecutionNumber(customerPackage.packageQuotationLines);
          this.updateExecutionNumber(customerPackage.testQuotationLines);
        });

        this.updateExecutionNumber(x.invoiceableItem.packages);

      });
      data.samples = this.orderDetailsMapperService.mapSampleDetails(x.order.samples, x.order.orderDetails.currencyCode,
        x.order.quotationContract.receivingLabAddress.city, attachments?.filter(y => y.linkedObjectType === LinkedObjectType.Sample));
      this.currentOrderService.currentOrder = data;
      callback();
    });
  }

  updateExecutionNumber = (lines: any[]) => {
    lines.forEach(line => {
      line.executionNumber = line.executionNumber > 0 ? line.executionNumber : 1;
    });
  };

  async getSampleQuantityDisplayFlagValue() {
    const enableSampleQuantity = await this.settingsService.getSettingValue(SettingsKey.EnableSampleQuantityDisplay);

   if(enableSampleQuantity?.toLowerCase() === LABSITE.toLowerCase()){
     const code = await this.currentOrderService.currentOrder.labDetails.code;
     await this.orderDataService.getSampleQuantityDisplayFlag(code).toPromise().then(flag => {
      this.sampleQuantityDisplayFlag = flag;
     });
   }
   else if (enableSampleQuantity?.toLowerCase() === ORDERINGSERVICE.toLowerCase()) {
    this.sampleQuantityDisplayFlag =  this.currentOrderService.currentOrder.orderTemplate.allowSampleQuantityDisplay;
   }
   return this.sampleQuantityDisplayFlag;
}
}


